import type { Asserts } from 'yup';

import { baseSchema } from '@/features/Input/inputBaseSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { hauSchema } from '@/features/Sparten/hau/schema/schema';

export const inputSchema = hauSchema.concat(baseSchema);

export type InputStore = Asserts<typeof inputSchema>;

export const useHauInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'HauInputStore',
);
